"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldCheck, ArrowRight, PhoneCall, CircleCheck, Activity } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourFuture() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const benefits = ["Εμπιστευτικότητα", "Νομική Εγκυρότητα", "ΦΑΝΗ ΠΟΥΡΑΪΜΗ - ΔΙΚΗΓΟΡΟΣ ΔΣΑ"];
  return <section data-section-id="87458" id="στρατιωτική-συμβουλευτική-για-στελέχη-εδ-σα" className="relative min-h-[90vh] flex items-center overflow-hidden dark bg-background text-foreground pt-24 pb-16 md:pt-32 md:pb-24">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute top-[20%] -right-[10%] w-[40%] h-[60%] rounded-full bg-secondary/5 blur-[100px]" />
        <div className="absolute -bottom-[20%] left-[20%] w-[60%] h-[50%] rounded-full bg-accent/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <ShieldCheck className="w-4 h-4" />
              <span className="font-sans">O Συνήγορος του ένστολου&nbsp;</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6 leading-[1.1] font-default">
              Στρατιωτική Συμβουλευτική για Στελέχη <span className="text-primary relative whitespace-nowrap">
                ΕΔ & ΣΑ
                <svg className="absolute -bottom-2 left-0 w-full h-3 text-primary/30" viewBox="0 0 100 10" preserveAspectRatio="none">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" />
                </svg>
              </span>
            </h1>
            
            <p className="text-lg sm:text-xl text-[#ADADAD] mb-8 leading-relaxed font-sans">
              Εξειδικευμένη υποστήριξη και καθοδήγηση για κάθε στάδιο της καριέρας σας. Από μεταθέσεις και αναφορές μέχρι συνταξιοδοτικά θέματα, είμαστε δίπλα στον Έλληνα ένστολο.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <Button asChild size="lg" className="h-14 px-8 text-base animate-pulse shadow-lg shadow-primary/20 bg-primary text-primary-foreground font-sans">
                
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base bg-background/50 backdrop-blur-sm border-primary text-primary font-sans">
                
              </Button>
            </div>

            <div className="flex flex-wrap gap-y-3 gap-x-6">
              {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-sm font-medium text-[#ADADAD] font-sans">
                  <CircleCheck className="w-4 h-4 text-primary" />
                  <span>{benefit}</span>
                </div>)}
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative lg:ml-auto w-full max-w-lg lg:max-w-none mx-auto transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-2xl aspect-[4/5] sm:aspect-square lg:aspect-[4/5] bg-muted border border-primary/20">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628303/img/hero_insurance_lifestyle.png" alt="Στρατιωτική Συμβουλευτική και Υποστήριξη" className="object-cover w-full h-full" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent mix-blend-multiply" />
            </div>

            {}
            <div ref={cardRef} className={`absolute -bottom-6 -left-6 sm:-left-12 sm:bottom-12 z-20 transition-all duration-700 delay-500 ease-out ${isCardVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}>
              <Card className="bg-card backdrop-blur-xl border-primary/50 shadow-xl w-64 overflow-hidden rounded-lg">
                <div className="absolute top-0 left-0 w-1 h-full bg-primary" />
                <CardContent className="p-5 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                    <Activity className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-lg font-bold text-white leading-tight font-default">
                      98% επιτυχία αναφορών – Βάσει υποθέσεων 2023-2025
                    </p>
                    <div className="flex items-center gap-1.5 mt-2">
                      <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                      </span>
                      <span className="text-xs text-[#ADADAD] font-medium font-sans">Πλήρης Κάλυψη</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
            
            {}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary/20 rounded-full blur-2xl -z-10" />
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-primary/10 rounded-full blur-2xl -z-10" />
          </div>

        </div>
      </div>
    </section>;
}